export const ADMIN_ROLE = 'admin';
export const STUDENT_ROLE = 'student';
export const ADMIN_SCHOOL = 'admin_school';
export const ADMIN_CLASS = 'admin_class'

export const roleCodeOptions = [
    {
        label: "VT0001 - Admin ICDL",
        value: "VT0001"
    },
    {
        label: "VT0002 - Admin Trường học",
        value: "VT0002"
    },
    {
        label: "VT0003 - Giáo viên",
        value: "VT0003"
    },
    {
        label: "VT0004 - Học sinh",
        value: "VT0004"
    },
]

export const mapRole = (role: string): string => {
    const roleMapping: { [key: string]: string } = {
        admin: 'admin',
        student: 'student',
        admin_school: 'adminschool',
        admin_class: 'teacher'
    };
    return roleMapping[role] || 'unknown';
}

// Loại vai trò (BE: Roles.role_type), nhãn ở locales role.type_<value>
export const roleTypeOptions = ['ADMIN', 'SCHOOL_ADMIN', 'TEACHING', 'LEARNING'];
